import { StyledModal, Title, Description, ButtonRow, CancelButton, EditButton } from './styles'

interface IncompleteApprovalModalProps {
  open: boolean
  onCancel: () => void
  onEdit: () => void
}

const IncompleteApprovalModal = ({ open, onCancel, onEdit }: IncompleteApprovalModalProps) => {
  return (
    <StyledModal
      open={open}
      centered
      footer={null}
      closable={false}
      maskClosable={false}
      width={416}
      destroyOnClose
    >
      <Title>ไม่สามารถส่งอนุมัติได้</Title>
      <Description>เนื่องจากยังระบุข้อมูลไม่ครบถ้วน</Description>
      <ButtonRow>
        <CancelButton onClick={onCancel}>ยกเลิก</CancelButton>
        <EditButton onClick={onEdit}>แก้ไข</EditButton>
      </ButtonRow>
    </StyledModal>
  )
}

export default IncompleteApprovalModal
